<template>
    <div class="hidden lg:block aspect-video">
        !{{ currentFile.src }}!
        <iframe
            width="100%"
            height="100%"
            class="absolute top-0 left-0 h-full w-full"
            controls
            :src="currentFileSrc"
        >
        </iframe>
    </div>
    <div class="block lg:hidden h-screen">
        <iframe
            class="w-full h-full"
            width="100%"
            height="100%"
            scrolling="auto"
            controls
            :src="currentFileSrcForGoogleDocs"
        >
        </iframe>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "FilePdf",
    computed: {
        ...mapGetters("player/view", ["currentFile"]),
        currentFileSrc() {
            return this.currentFile?.src ? `${this.currentFile.src}#toolbar=0` : "";
        },
        currentFileSrcForGoogleDocs() {
            return this.currentFile?.src
                ? `https://docs.google.com/viewerng/viewer?embedded=true&url=${this.currentFile.src}#toolbar=0`
                : "";
        },
    },
};
</script>
